import { injectGlobal } from 'react-emotion'

import { colors, fonts } from './vars'

// Fonts
injectGlobal(`@font-face {
  font-family: 'Work Sans';
  src: url('/fonts/hinted-WorkSans-SemiBold.eot');
  src: url('/fonts/hinted-WorkSans-SemiBold.eot?#iefix') format('embedded-opentype'),
      url('/fonts/hinted-WorkSans-SemiBold.woff2') format('woff2'),
      url('/fonts/hinted-WorkSans-SemiBold.woff') format('woff'),
      url('/fonts/hinted-WorkSans-SemiBold.ttf') format('truetype'),
      url('/fonts/hinted-WorkSans-SemiBold.svg#WorkSans-SemiBold') format('svg');
  font-weight: 600;
  font-style: normal;
}`)

injectGlobal(`@font-face {
  font-family: 'Work Sans';
  src: url('/fonts/hinted-WorkSans-Regular.eot');
  src: url('/fonts/hinted-WorkSans-Regular.eot?#iefix') format('embedded-opentype'),
      url('/fonts/hinted-WorkSans-Regular.woff2') format('woff2'),
      url('/fonts/hinted-WorkSans-Regular.woff') format('woff'),
      url('/fonts/hinted-WorkSans-Regular.ttf') format('truetype'),
      url('/fonts/hinted-WorkSans-Regular.svg#WorkSans-Regular') format('svg');
  font-weight: normal;
  font-style: normal;
}`)

injectGlobal(`@font-face {
  font-family: 'Grotzec Cond';
  src: url('/fonts/hinted-GrotzecCondBold-Regular.eot');
  src: url('/fonts/hinted-GrotzecCondBold-Regular.eot?#iefix') format('embedded-opentype'),
      url('/fonts/hinted-GrotzecCondBold-Regular.woff2') format('woff2'),
      url('/fonts/hinted-GrotzecCondBold-Regular.woff') format('woff'),
      url('/fonts/hinted-GrotzecCondBold-Regular.ttf') format('truetype'),
      url('/fonts/hinted-GrotzecCondBold-Regular.svg#GrotzecCondBold-Regular') format('svg');
  font-weight: bold;
  font-style: normal;
}`)

injectGlobal(`h1 {
  font-family: ${fonts.heading};
  font-weight: bold;
  font-size: 64px;
  line-height: 1.375;
  letter-spacing: -1.2;
  margin-top: 0;
}`)

injectGlobal(`h2 {
  font-family: ${fonts.heading};
  font-weight: bold;
  font-size: 40px;
  line-height: 1.2;
  letter-spacing: -1;
  margin: 0 0 20px;
}`)

injectGlobal(`.h2 {
  font-family: ${fonts.heading};
  font-weight: bold;
  font-size: 40px;
  line-height: 1.2;
  letter-spacing: -1;
  margin: 0 0 20px;
}`)

injectGlobal(`h3 {
  font-family: ${fonts.heading};
  font-weight: bold;
  font-size: 36px;
  line-height: 1.33;
  margin-top: 0;
}`)

injectGlobal(`h4 {
  font-family: ${fonts.heading};
  font-weight: bold;
  font-size: 24px;
  line-height: 1.5;
  margin-top: 0;
}`)

injectGlobal(`h5 {
  font-family: ${fonts.heading};
  font-weight: bold;
  font-size: 16px;
  line-height: 1.5;
  margin-top: 0;
}`)

injectGlobal(`h6 {
  font-family: ${fonts.heading};
  font-weight: bold;
  font-size: 10px;
  line-height: 1.6;
  letter-spacing: 1;
  margin-top: 0;
}`)

injectGlobal(`button {
  font-family: ${fonts.heading};
  font-weight: bold;
  font-size: 14px;
  line-height: 1.14;
}`)

injectGlobal(`html,body {
  font-family: ${fonts.body};
  color: ${colors.black};
  font-size: 16px;
  line-height: 1.5;
}`)

injectGlobal(`p.large {
  font-family: ${fonts.body};
  font-weight: 600;
  font-size: 20px;
  line-height: 1.4;
}`)

injectGlobal(`p {
  margin-top: 0;
  margin-bottom: 18px;
}`)

injectGlobal(`p.small {
  font-family: ${fonts.body};
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;
}`)

injectGlobal(`blockquote {
  font-size: 32px;
  line-height: 1.5;
}`)

injectGlobal(`::selection {
  background-color: ${colors.primary};
  color: ${colors.white};
}`)

injectGlobal(`hr {
  border-color: ${colors.primary};
  border-style: solid;
  border-width: 1px 0 0 0;
  max-width: 60%;
}`)

injectGlobal(`ul {
  padding-left: 18px;
}`)


injectGlobal(`form {

  label {
    font-family: ${fonts.heading};
    display: block;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.5;
    margin-bottom: 10px;
  }
   
  input,
  textarea {
    display: block;
    font-size: 14px;
    line-height: 1.25;
    box-sizing: border-box;
    width: 100%;
    border: 2px solid ${colors.greyL};
    border-radius: 8px;
    padding: 14px;
    
    &:focus,
   &:active {
      border-color: ${colors.primary};
      outline: none;
    }
  }
}`)



// WEBPACK FOOTER //
// ./src/styles/base.js